import { msg } from '../messages'
import { nonWhitespaces } from './nonWhitespaces'

const REGEX_LOTE = '^[a-zA-Z0-9áéíóúÁÉÍÓÚçÇâêôÂÊÔõãÕÃäöüÄÖÜàÀ. /&,-]+$'
const REGEX_FABRICANTE = '^[a-zA-Z0-9áéíóúÁÉÍÓÚçÇâêôÂÊÔõãÕÃäöüÄÖÜàÀ. /&(),-]+$'

export function nomeLote(value: string) {
  return nonWhitespaces(value) ?? validaNomeLote(value)
}

export const nomeFabricante = (value: string) => validaNomeFabricante(value)

function validaNomeLote(value: string) {
  if (!new RegExp(REGEX_LOTE).test(value)) {
    return msg('match', value)
  }
  return null
}

function validaNomeFabricante(value: string) {
  if (!new RegExp(REGEX_FABRICANTE).test(value)) {
    return msg('match', value)
  }
  return null
}
